import { render, staticRenderFns } from "./HistoryItemDetails.vue?vue&type=template&id=d10e1f7c&scoped=true"
import script from "./HistoryItemDetails.vue?vue&type=script&lang=ts"
export * from "./HistoryItemDetails.vue?vue&type=script&lang=ts"
import style0 from "./HistoryItemDetails.vue?vue&type=style&index=0&id=d10e1f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10e1f7c",
  null
  
)

export default component.exports